import { cva, type VariantProps } from 'class-variance-authority';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

const pill = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
  {
    variants: {
      tone: {
        neutral: 'border-border bg-surface-muted text-fg',
        success: 'border-success-subtle bg-success-subtle text-success-strong',
        warning: 'border-warning-subtle bg-warning-subtle text-warning-strong',
        danger: 'border-danger-subtle bg-danger-subtle text-danger-strong',
        info: 'border-info-subtle bg-info-subtle text-info-strong',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface StatusPillProps extends VariantProps<typeof pill> {
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

/** Status is never color-only — icon + label + color. */
export function StatusPill({ tone, icon: Icon, children, className }: StatusPillProps) {
  return (
    <span className={cn(pill({ tone }), className)}>
      {Icon ? <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : null}
      <span>{children}</span>
    </span>
  );
}
